import { useState } from "react";
import ResourceList from "../resources/ResourceList";
import { resourcesConfig } from "../resources/resourcesConfig";
import CrearSedeModal from "./CrearSedeModal";

const Sedes = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Necesitamos un key para forzar la recarga del ResourceList
    const [refreshKey, setRefreshKey] = useState(0);

    const handleSuccess = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <>
            <ResourceList
                key={refreshKey}
                {...resourcesConfig.sedes}
                secondaryActionLabel="+ Crear Sede"
                onSecondaryAction={() => setIsModalOpen(true)}
            />

            {isModalOpen && (
                <CrearSedeModal
                    onClose={() => setIsModalOpen(false)}
                    onSuccess={handleSuccess}
                />
            )}
        </>
    );
};

export default Sedes;